import { Loader2 } from "lucide-react";
import { Link } from "react-router";

import { AssessmentTable } from "@/components/assessment-table";
import { Eyebrow } from "@/components/eyebrow";
import { PageShell } from "@/components/page-shell";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useAssessments } from "@/lib/api";

export function ExpertQueuePage() {
  const query = useAssessments();
  const rows = query.data ?? [];

  return (
    <PageShell wide>
      <Eyebrow>Expert review</Eyebrow>
      <h1 className="text-primary mt-3 text-4xl font-normal tracking-tight sm:text-5xl">
        The review queue.
      </h1>
      <p className="text-muted-foreground mt-4 mb-7 text-lg">
        Every completed assessment. Open one to review the report and record a calibration before it
        reaches the client.
      </p>

      {query.isLoading && (
        <div className="flex justify-center py-24">
          <Loader2 className="text-muted h-6 w-6 animate-spin" />
        </div>
      )}
      {query.error != null && (
        <Card>
          <CardContent className="pt-6 text-center">
            <p className="text-muted-foreground text-sm">
              Couldn’t load the review queue. Please try again.
            </p>
            <Button variant="outline" className="mt-4" onClick={() => void query.refetch()}>
              Retry
            </Button>
          </CardContent>
        </Card>
      )}
      {query.data &&
        (rows.length === 0 ? (
          <Card>
            <CardContent className="pt-6">
              <p className="text-muted text-sm">
                No assessments yet. Once a client completes the{" "}
                <Link to="/assess" className="text-accent hover:underline">
                  assessment
                </Link>
                , it appears here.
              </p>
            </CardContent>
          </Card>
        ) : (
          <AssessmentTable
            rows={rows}
            linkLabel="Review →"
            linkTo={(id) => `/expert/${id}`}
            showClient
          />
        ))}
    </PageShell>
  );
}
